import React from 'react';

import Icon from '../../../components/Icon/Icon';

const softwareItem = ( props ) => (
	<a href={ props.url } target="_blank" rel="noopener noreferrer">
		<Icon icon={ props.icon } title={ props.title } />
	</a>
);

export default softwareItem;



// WEBPACK FOOTER //
// ./src/pages/IT/SoftwareList/SoftwareItem.js